import { baseUrls, apiUrls } from "../../../utils/Endpoints.config";
import { getAxiosConfig, getFomatedError, setFormatedResponse } from "../services/apiService";

/* Add Position Service */
const addPosition = (params) => {
  const { axiosInstance,config } = getAxiosConfig();
  const response = axiosInstance({
    url: `${baseUrls.main}/${apiUrls.admin.createPosition}`,
    method: "POST",
    data: params,
    headers: config.headers ||null,
    mode: "no-cors",
  })
    .then((res) => {
      return setFormatedResponse(res);
    })
    .catch((error) => {
      return getFomatedError(error);
    });
  return response;
};

/* Get Position Service */
const getAllPosition = (params) => {
    const { axiosInstance ,config,source} = getAxiosConfig();
    const response = axiosInstance({
      url: `${baseUrls.main}/${apiUrls.admin.getAllPositions}`,
      method: "GET",
      params: params,
      headers: config.headers ||null,
      mode: "no-cors",
    })
      .then((res) => {
        return setFormatedResponse(res);
      })
      .catch((error) => {
        return getFomatedError(error);
      });
    return response;
  };

  /* Get Position Position By Department Designation Service */
const getPositionByDepartmentDesignation = (params) => {
    const { axiosInstance ,config,source} = getAxiosConfig();
    const response = axiosInstance({
      url: `${baseUrls.main}/${apiUrls.admin.getPositionByDepartmentDesignation}`,
      method: "GET",
      params: params,
      headers: config.headers ||null,
      mode: "no-cors",
    })
      .then((res) => {
        return setFormatedResponse(res);
      })
      .catch((error) => {
        return getFomatedError(error);
      });
    return response;
  };


  /* Update Position Service */
  const updatePosition = (params) => {
    const { axiosInstance,config } = getAxiosConfig();
    const response = axiosInstance({
      url: `${baseUrls.main}/${apiUrls.admin.updatePosition}`,
      method: "PUT",
      data: params,
      headers: config.headers ||null,
      mode: "no-cors",
    })
      .then((res) => {
        return setFormatedResponse(res);
      })
      .catch((error) => {
        return getFomatedError(error);
      });
    return response;
  };


   /* Delete Position Service */
   const deletePosition = (params) => {
    const { axiosInstance ,config} = getAxiosConfig();
    const response = axiosInstance({
      url: `${baseUrls.main}/${apiUrls.admin.deletePosition}`,
      method: "DELETE",
      data: params,
      headers: config.headers ||null,
      mode: "no-cors",
    })
      .then((res) => {
        return setFormatedResponse(res);
      })
      .catch((error) => {
        return getFomatedError(error);
      });
    return response;
  };

export default {
    addPosition,
    getAllPosition,
    getPositionByDepartmentDesignation,
    updatePosition,
    deletePosition,

}